import Spinner from 'components/Spinner'
import { useEffect, useState } from 'react'
import Map from './Map'

const App = (props: any) => {
  const [latitude, setLatitude] = useState<number | null>(null)
  const [longitude, setLongitude] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      position => {
        setLatitude(position.coords.latitude)
        setLongitude(position.coords.longitude)
        setLoading(false)
      },
      error => {
        console.error('Error getting geolocation:', error)
        setLoading(false)
      },
    )
  }, [])

  if (loading) {
    return (
      <div className="h-20 flex justify-center align-center">
        <Spinner />
      </div>
    )
  }
  return (
    <div style={{ marginTop: '50px' }}>
      <Map
        onSubmit={props.onSubmit}
        google={props.google}
        center={{
          lat: latitude !== null ? latitude : 37.2428698,
          lng: longitude !== null ? longitude : -121.9231999,
        }}
        mapData={props.mapData}
        title={props.title}
        height="300px"
        zoom={15}
        onlyView={props.onlyView}
      />
    </div>
  )
}

export default App
